import {SystemMemoryProps} from "../models/SystemMemoryProps";
import {NavMenu} from "../components/GetNavMenu";
import React from "react";
import {Footer} from "../components/GetFooter";
import {RenderPortfolioGrid} from "../components/portfolio/PortfolioGrid";

export function Portfolio({memory}: SystemMemoryProps) {
    return (
        <>
            <NavMenu memory={memory} />

            <RenderPortfolioGrid rows={3} page={1} memory={{memory: memory}} />

            <Footer data={[]} />
        </>
    )
}